import { render, staticRenderFns } from "./fuliguan.vue?vue&type=template&id=9e6c4ece&scoped=true&"
import script from "./fuliguan.vue?vue&type=script&lang=js&"
export * from "./fuliguan.vue?vue&type=script&lang=js&"
import style0 from "./fuliguan.vue?vue&type=style&index=0&id=9e6c4ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6c4ece",
  null
  
)

export default component.exports